import type { ReactNode } from 'react';
import { Head } from '@inertiajs/react';

import ProsopiteErrorNotifier from '@/components/development/prosopite-error-notifier';
import InertiaMetaTags from '@/components/inertia-meta-tags';
import IntercomWidget from '@/components/shared/intercom-widget';
import { SkipToContent } from '@/components/shared/skip-to-content';
import { Toaster } from '@/components/ui/toast';
import { useAccountChangeReset } from '@/hooks/use-account-change-reset';
import AppShell from '@/layouts/app/app-shell';

export default function CMSLayout({ children }: { children: ReactNode }) {
  useAccountChangeReset();

  return (
    <>
      <InertiaMetaTags />
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>

      <SkipToContent />
      <div id="cms-layout">
        <IntercomWidget />
        <Toaster />
        <ProsopiteErrorNotifier />
        <AppShell>{children}</AppShell>
      </div>
    </>
  );
}
